// eslint-disable-next-line no-restricted-imports
import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	fallbackSuggestedTitle: {
		id: 'fabric.editor.ai.eventHub.fallbackSuggestedTitle',
		defaultMessage: 'Page title',
		description: 'A fallback suggested title for the suggest title prompt',
	},
});
